<template>
    <nut-popup v-model:visible="visible" style="background-color: transparent" @close="closeModal">
        <div class="dialog-content">
            <div class="content-box">
                <div class="qr-box">
                    <div class="qr">
                        <!-- <TxImage src="erweima" :size="{ width: 184, height: 184 }" /> -->
                        <img :src="currentQrCodeObj.hutong" alt="">
                    </div>
                    <div class="qr">
                        <!-- <TxImage src="erweima" :size="{ width: 184, height: 184 }" /> -->
                        <img :src="currentQrCodeObj.saiji" alt="">
                    </div>
                </div>
                <div class="qr-name">
                    <span>万象互通讨论群</span>
                    <span>弱水三千玩家群</span>
                </div>
                <div class="tip">经典版共创中，社群待后续开放</div>
            </div>
            <div class="close-box" @click="closeModal">
                <TxButton src="gb" name="关闭入群指引弹窗">
                </TxButton>
            </div>
        </div>
    </nut-popup>
</template>

<script lang="ts" setup>
import { computed, inject, ref, } from 'vue';
import eventEmitter from '@utils/event';
const { channel } = inject('GlobalStore');
import { qrObj } from '../constant';


eventEmitter.on('showGroupGuideModal', () => {
    visible.value = true
});

const visible = ref(false)

const currentQrCodeObj = computed(() => {
    
    if (!!channel.extra && channel.extra.startsWith('RCL')) {
        console.log('显示RCL的二维码');
        return qrObj.RCL
    } else {
        console.log('显示默认的二维码');
        return qrObj.default
    }
})

function closeModal() {
    visible.value = false
}

</script>

<style lang="scss" scoped>
.dialog-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 24px;

    .content-box {
        position: relative;
        @include bg('jinqunBG');
        box-sizing: border-box;
        padding-top: 326px;
        padding-right: 2px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .qr-box {
            display: flex;
            justify-content: center;

            .qr {
                width: 184px;
                height: 184px;
                // background-color: #acf;

                &:first-child {
                    margin-right: 70px;
                }

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .qr-name {
            display: flex;
            margin-top: 15px;
            span {
                width: 184px;
                text-align: center;
                color: #202632;

                &:first-child {
                    margin-right: 70px;
                }
            }
        }

        .tip {
            position: absolute;
            left: 0;
            bottom: 80px;
            width: 100%;
            text-align: center;
            color: #202632;
        }
    }

    .close-box {
        width: 100%;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .close-icon {
            color: #fff;
        }
    }
}
</style>